import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, EditIcon, PopupContentContainer, ScrollableContainer, ShareIcon, TrashCanIcon, } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { useShare } from '../../hooks/useShare';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { ScheduleService } from '../../services/schedule/ScheduleService';
import { CenterRight, Popup } from '../../utils/popups';
import { formBroadcastPath, formBroadcastUrl } from '../../utils/url';
import { BroadcastNameplate } from '../BroadcastNameplate';
import { StackContent } from '../Stack';
import { HideGlobalScrollbar } from '../shared/HideGlobalScrollbar';
import { TextButton } from '../TextButton';
import { BroadcastName } from '../Ui';
import { AbstractPopup } from './AbstractPopup';
import { confirm } from './ConfirmationPopup';
import { PopupCssPreset } from './Popup.styles';
import { scheduleSession } from './ScheduleSessionPopup';
export function SessionItemInfoPopup({ resolve, session, ...props }) {
    const { canShare, openSystemShareDialog } = useShare();
    const scheduleService = ScheduleService.getNotificationInterface();
    const navigate = useNavigate();
    const activateSession = () => {
        BroadcastStateService.getInstance().notifySetActiveBroadcast({
            ...session,
            myRole: 'broadcaster',
        });
        navigate(formBroadcastPath(session, '/alpha'));
    };
    return (_jsxs(SessionItemInfoPopupRoot, { translateFn: CenterRight, ...props, children: [_jsx(Wrap, { children: _jsx(Content, { children: _jsxs(StackContent, { children: [_jsxs(Header, { children: [_jsx(TextButton, { type: "button", onClick: () => {
                                            resolve();
                                        }, children: "Done" }), _jsx(BroadcastName, { children: session.name })] }), _jsx(BroadcastNameplate, { broadcast: session, onActivateBroadcastClick: () => {
                                    resolve();
                                    setTimeout(() => {
                                        activateSession();
                                    }, 250);
                                } }), _jsx(StyledButton, { type: "button", onClick: () => {
                                    if (session) {
                                        scheduleSession(session);
                                    }
                                    resolve();
                                }, children: _jsxs(StyledPopupContentContainer, { children: [_jsx(EditIcon, {}), _jsx("span", { children: "Edit" })] }) }), canShare && (_jsx(StyledButton, { type: "button", onClick: () => {
                                    openSystemShareDialog(formBroadcastUrl(session));
                                }, children: _jsxs(StyledPopupContentContainer, { children: [_jsx(ShareIcon, {}), _jsx("span", { children: "Share" })] }) })), _jsx(StyledButton, { type: "button", onClick: async () => {
                                    resolve();
                                    if (await confirm({
                                        title: 'Delete session',
                                        okLabel: 'Delete',
                                        cancelLabel: 'Cancel',
                                        message: (_jsx(_Fragment, { children: "This link will no longer work for anyone who's received it." })),
                                    })) {
                                        scheduleService.notifyDeleteScheduledSession(session.id);
                                    }
                                }, children: _jsxs(StyledPopupContentContainer, { children: [_jsx(TrashCanIcon, {}), _jsx("span", { children: "Delete" })] }) })] }) }) }), _jsx(HideGlobalScrollbar, {})] }));
}
const Content = styled(ScrollableContainer) `
    height: calc(var(--vh, 1vh) * 100 - 2rem);

    @media (min-width: 30rem) {
        height: auto;
        max-height: calc(
            var(--vh, 1vh) * 100 - 2 * var(--Popup_BoundingBoxPadding, 1rem) -
                2rem
        );
    }
`;
const Wrap = styled.div `
    padding: 1rem 0;

    ${StackContent} {
        padding: 0 1rem;
    }
`;
const Header = styled.div `
    ${BroadcastName} {
        margin: 1.5rem 0;
    }
`;
const SessionItemInfoPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    --Popup_Padding: 0;

    @media (min-width: 30rem) {
        ${PopupCssPreset.AnchoredRight};
        --Popup_Width: 20.75rem;
        /* Max height of this popup is driven but the max-height of Content component. See above. */
        --Popup_MaxHeight: none;

        ${Header} {
            display: none;
        }
    }
`;
const StyledButton = styled(Button) `
    --Button_HoverTransform: 0;
    --Button_ActiveTransform: 0;
`;
const StyledPopupContentContainer = styled(PopupContentContainer) `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.5rem;
`;
const sessionItemInfoPopup = Popup.create(SessionItemInfoPopup);
export function showSessionInfo(session, options = {}) {
    executeSoon(async () => {
        options.onOpenPopup?.();
        try {
            await sessionItemInfoPopup.pop({
                session,
                anchorRef: options.anchorRef,
            });
        }
        catch (_ignore) {
        }
        finally {
            options.onClosePopup?.();
        }
    });
}
